module.exports = __webpack_public_path__ + "media/images/emoticons/watch-0ee71897b4955450dec9a5c782dbda38.gif";